<template>
	<div>
		<div class="searchBanner">
			<div class="w1200">
				<div class="search1">
					<input type="text" placeholder="Search" v-model="keyword" @focus="showsug(1)"
						@keyup="showsug(0)" @blur="hidesug()" @keypress.enter="searchJump()" />
					<i id="sEmpty" v-show="keyword" @click="clearword"></i>
					<div class="searchBtn1" @click="searchJump()"><em></em>搜索</div>
				</div>
				<div class="search_dropdown" v-show="showsugflag&&sugwordsList.length">
					<ul class="hotkeywords">
						<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item,0)">
							<btn
								v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')">
							</btn>
						</li>
					</ul>
				</div>
				<div class="searchPop1" v-show="showhistroyflag">
					<div class="history">
						<input type="button" class="del" @mousedown.prevent="removehistoryall" value="清空全部" />
						<p>检索历史</p>
						<div class="clearfix"></div>
						<ul>
							<li v-for="(item,index) in keyhistory">
								<span style="cursor: pointer;" @mousedown="selhistory(item,1)">{{item}}</span>
								<i @mousedown.prevent="removehistory(item)"></i>
							</li>
							<!-- <li><span>经济形势</span><i></i></li>
		                <li><span>水利建设</span><i></i></li>
		                <li><span>水网</span><i></i></li>
		                <li><span>算力</span><i></i></li>
		                <li><span>环境基础设施</span><i></i></li> -->
						</ul>
					</div>
					<div class="hotWord">
						<p>检索热词</p>
						<ul>
							<li v-for="(item,index) in hotwords" @mousedown="selhistory(item,2)">
								{{item}}
							</li>
							<!-- <li>数据中心</li>
		                <li>省事副中心</li>
		                <li>产业</li>
		                <li>灵活就业</li>
		                <li>脱贫攻坚</li> -->
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="searchBg" v-show="showhistroyflag||showsugflag" @click="hidesug()"></div> -->
		<div class="w1200">

			<div v-if="(searchword&&totalResultCount)||loadingMask" v-loading="loadingMask">
				<ul class="tab1">
					<li @click="searchColumChange('')" :class="searchColum==''?'curr':''"><span>综合</span></li>
					<li v-for="(item,index) in resultColumnList" @click="searchColumChange(item.columnID)"
						:class="searchColum==item.columnID?'curr':''">
						<span>{{item.columnName}}({{item.AtlCount}})</span>
					</li>
				</ul>
				<!-- <div style="text-align: right">
					    <div class="dropDate">
					        <span>时间不限</span><img src="/images/dIcon.png"/>
					    </div>
					</div> -->
				<div class="Tabnav_box">
					<!-- Tabnav_box -->
					<div class="Tabnav_box_L">
					</div>
					<div class="Tabnav_box_R2">

						<div id="datePanelDiv" class="Tabnav_out" name="Tabnav_out" @click="showDatePanel()">
							<!-- Tabnav_out -->
							<div class="Tabnav_screen2" name="Tabnav_screen">{{dateTypeText}}<img
									:src="datePanelVisible?'/images/dIcon.png':'/images/down.png'" style="margin-left: 10px;" /></div>
							<!-- <el-collapse-transition> -->
							<ul class="Tabnav1" name="Tabnav" style="right: 0;" v-show="datePanelVisible">
								<li @click.stop="dateClick(0,'时间不限')" :class="dateType==0?'on':''">时间不限</li>
								<li @click.stop="dateClick(1,'一周内')" :class="dateType==1?'on':''">一周内</li>
								<li @click.stop="dateClick(2,'一月内')" :class="dateType==2?'on':''">一月内</li>
								<li @click.stop="dateClick(3,'一年内')" :class="dateType==3?'on':''">一年内</li>
								<li @click.stop="dateClick(4,'自定义')" :class="dateType==4?'on':''">
									<div>自定义</div>
									<div class="" v-on:click.stop>
										<el-date-picker v-model="dateStr" type="daterange" value-format="yyyy-MM-dd"
											range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
											@change="dateClick(4,'自定义')">
										</el-date-picker>
									</div>
								</li>

							</ul>
							<!-- </el-collapse-transition> -->
						</div><!-- /Tabnav_out -->

					</div>
				</div><!-- /Tabnav_box -->
				<div id="con_a_1">
					<ul class="searchList">
						<li v-for="(result,index) in resultDataList" :key="result.id">
							<router-link target="_blank" @click.native="$track([['pagetype','检索中心-关键词:'+searchword+'-第'+pageNum+'页-第'+(index+1)+'篇-点击']])"
								:to="{ name: 'detail', params: { id: result.id }, query:{ key: searchword }}">
								<span v-html="result.title.replace(/color:Red/g,'color:#2C68FF;')"></span>
								<i></i>
							</router-link>
							<!-- <a href="detail1.html">数据里的“中国活力” | <span>工业互联网</span>赋能多行业实体经济<i></i></a> -->
							<p v-if="result.content&&result.content.indexOf('.pdf</attachment>')>-1">
								<span v-html="result.summary"></span>
							</p>

							<p
								v-else-if="resultHitList[index]&&resultHitList[index].hitPara&&resultHitList[index].hitPara.length>0">
								<span
									v-html="resultHitList[index].hitPara[0].text.replace(/color:Red/g,'color:#2C68FF;')"></span>
							</p>

							<p v-else style="margin-bottom: 16px;">

							</p>

							<em>{{result.publishtime?result.publishtime.substring(0,10):''}}
								<i v-if="result.exattribute8" @click="showZCJD(result.id)">政策解读</i>
							</em>
						</li>
						<!-- <li>
					            <a href="detail1.html">中国移动政企科创专题：OneOS带来<span>工业互联网</span>“鲶鱼效应”<i></i></a>
					            <p>今天，我们要关注的是工业互联网。近年来，工业互联网加速向实体经济渗透，已在工业、医疗、教育、交通等多个行业的领域发挥极大的赋能效应。</p>
					            <em>2022-08-04<i>政策解读</i></em>
					        </li>
					        <li>
					            <a href="detail1.html"><span>工业互联网</span>工程师：为制造业升级插上数字化羽翼<i></i></a>
					            <p>以湖北交通投资集团有限公司（以下简称“湖北交投”）信息化规划研究为例。中国信通院与湖北交投自2019年开始开展规划工作，历时1年有余，期间克服疫情影响，最终高质量的完成了信息化战略规划成果，提出了“坚持创新驱动，推动数字转型，打造协同共享、融合开放的智慧交投”数字转化型战略。中国信通院与湖北交投更进...</p>
					            <em>2022-08-04<i>政策解读</i></em>
					        </li>
					        <li>
					            <a href="detail1.html">“万能身份证”打通数据链 联通<span>工业互联网</span>标识解析助推产业数字化<i></i></a>
					            <p>以湖北交通投资集团有限公司（以下简称“湖北交投”）信息化规划研究为例。中国信通院与湖北交投自2019年开始开展规划工作，历时1年有余，期间克服疫情影响，最终高质量的完成了信息化战略规划成果，提出了“坚持创新驱动，推动数字转型，打造协同共享、融合开放的智慧交投”数字转化型战略。中国信通院与湖北交投更进...</p>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html">把<span>工业互联网</span>做大做强<i></i></a>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html">深入推进<span>工业互联网</span>六大模式<i></i></a>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html">陕西省开展<span>工业互联网</span>安全检查<i></i></a>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html"><span>工业互联网</span>加快重点行业运用<i></i></a>
					            <p>以湖北交通投资集团有限公司（以下简称“湖北交投”）信息化规划研究为例。中国信通院与湖北交投自2019年开始开展规划工作，历时1年有余，期间克服疫情影响，最终高质量的完成了信息化战略规划成果，提出了“坚持创新驱动，推动数字转型，打造协同共享、融合开放的智慧交投”数字转化型战略。中国信通院与湖北交投更进...</p>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html">2022年，<span>工业互联网</span>能带来多少经济增长?<i></i></a>
					            <p>以湖北交通投资集团有限公司（以下简称“湖北交投”）信息化规划研究为例。中国信通院与湖北交投自2019年开始开展规划工作，历时1年有余，期间克服疫情影响，最终高质量的完成了信息化战略规划成果，提出了“坚持创新驱动，推动数字转型，打造协同共享、融合开放的智慧交投”数字转化型战略。中国信通院与湖北交投更进...</p>
					            <em>2022-08-04</em>
					        </li>
					        <li>
					            <a href="detail1.html">2022中国<span>工业互联网</span>标识应用大会（中部）召开<i></i></a>
					            <p>以湖北交通投资集团有限公司（以下简称“湖北交投”）信息化规划研究为例。中国信通院与湖北交投自2019年开始开展规划工作，历时1年有余，期间克服疫情影响，最终高质量的完成了信息化战略规划成果，提出了“坚持创新驱动，推动数字转型，打造协同共享、融合开放的智慧交投”数字转化型战略。中国信通院与湖北交投更进...</p>
					            <em>2022-08-04</em>
					        </li> -->
					</ul>
					
					<div v-if="pageNum==1" class="footerBar">
					  <span>不是期望的结果？</span>
					  <a @click="showfankui">提交反馈</a>
					</div>
					
					<div class="pagediv">
						<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
							:current-page="pageNum" :page-sizes="[10, 15, 20]" :page-size="pageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="totalResultCount">
						</el-pagination>
					</div>
				</div>
				<!-- <div id="con_a_2" style="display: none">
					    <div class="emp">
					        <img src="images/no1.png"/>
					        <p>抱歉~当前类型暂无数据，可尝试更换关键字~</p>
					    </div>
					</div> 
					<div id="con_a_3" style="display: none">3</div> 
					<div id="con_a_4" style="display: none">4</div> 
					<div id="con_a_5" style="display: none">5</div> 
					<div id="con_a_6" style="display: none">6</div> -->
			</div>

			<!-- 默认无数据 开始-->
			<div class="emp" v-else-if="!searchword">
				<img src="/images/no.png" />
				<p>暂无数据，输入关键字进行搜索吧~</p>
			</div>
			<!-- 默认无数据 结束-->
			<!-- 检索无数据 开始-->
			<div class="emp" v-else>
				<img src="/images/no1.png" />
				<p>抱歉~暂无数据，可尝试更换关键字~</p>
			</div>
			<!-- 检索无数据 结束-->
		</div>

		<div class="explain" v-show="zcjdPanelVisible">
			<div class="explainbg" @click="hideZCJD"></div>
			<div class="explainWap">
				<a class="close" @click="hideZCJD"></a>
				<img src="/images/head.png" />
				<ul v-loading="loadingMaskZcjd">
					<li v-for="(item,index) in zcjdresultDataList">
						<router-link target="_blank" :to="{ name: 'detail', params: { id: item.id }}">
							{{item.articletitle}}<img src="/images/arw_bule.png" />
						</router-link>
						<!-- <a href="##">中央一号文件公布加快农业农村现代化推进乡村振兴<img src="/images/arw_bule.png"/></a> -->
						<p>{{item.summary.length>80?item.summary.substring(0,80)+'...':item.summary}}</p>
						<em>{{item.publishtime?item.publishtime.substring(0,10):''}}</em>
					</li>
					<!-- <li>
		              <a href="##">官方解读 | “双碳”背景下首部地方性电力法规<img src="images/arw_bule.png"/></a>
		              <p>4月29日，乡村振兴促进法油中华人民共和国第十三届全国人民代表大会常务委员会
		                  第二十八次会议通过，公布后自2021年6月1日起施行。会后，全国人大常委会法制
		                  工作委员会和农业农村部有关部门负责人就乡村振兴促进农业高质高...</p>
		              <em>2021 / 10 / 03</em>
		          </li>
		          <li>
		              <a href="##">解读《江西省碳达峰实施方案》<img src="images/arw_bule.png"/></a>
		              <p>4月29日，乡村振兴促进法油中华人民共和国第十三届全国人民代表大会常务委员会
		                  第二十八次会议通过，公布后自2021年6月1日起施行。会后，全国人大常委会法制
		                  工作委员会和农业农村部有关部门负责人就乡村振兴促进农业高质高...</p>
		              <em>2021 / 10 / 03</em>
		          </li>
		          <li>
		              <a href="##">解读｜2021全国可再生能源电力发展最全解读<img src="images/arw_bule.png"/></a>
		              <p>4月29日，乡村振兴促进法油中华人民共和国第十三届全国人民代表大会常务委员会
		                  第二十八次会议通过，公布后自2021年6月1日起施行。会后，全国人大常委会法制
		                  工作委员会和农业农村部有关部门负责人就乡村振兴促进农业高质高...</p>
		              <em>2021 / 10 / 03</em>
		          </li> -->
				</ul>
				<div class="pagediv">
					<el-pagination @current-change="zcjdchangeSearchPage" :current-page="zcjdpageNum" :page-size="10"
						layout="total, prev, pager, next" :total="zcjdtotalResultCount">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				loadingMaskZcjd: false,
				searchType: '1',
				searchColum: '',
				searchword: '',
				keyword: '',
				cachekeyword: '',
				showsugflag: false,
				sugdelaytimer: '',
				sugstaytimer: '',
				sugwordsList: [],
				showhistroyflag: false,
				ishistoryaction: false,
				keyhistory: [],
				hotwords: [],
				pageNum: 1,
				pageSize: 10,
				totalResultCount: '',
				resultDataList: [],
				resultHitList: [],
				totalColumnCount: 0,
				resultColumnList: [],
				zcjdPanelVisible: false,
				zcjdpageNum: 1,
				zcjdtotalResultCount: 0,
				zcjdresultDataList: [],
				relateDataList: [],
				datePanelVisible: false,
				dateType: 0,
				dateTypeText: '时间不限',
				searchdate: '',
				dateStr: ''
			}
		},
		mounted: function() {
			this.gethotwordfnc();
			this.searchClick();
		},
		watch: {
			$route(to, from) {
				if (to.params.searchword != from.params.searchword) {
					this.searchClick();
				}
			}
		},
		methods: {
			clearword: function() {
				this.keyword = '';
				this.cachekeyword = '';
			},
			showsug: function(fromflag) {
				// debugger
				if (this.keyword) {
					if (this.cachekeyword != this.keyword) {
						// this.sugwordsList=[];
						// clearTimeout(this.sugdelaytimer)
						// let _timerthis=this;
						// this.sugdelaytimer = setTimeout(function (){
						// _timerthis.getsugfnc();
						// _timerthis.showsugflag = true;
						// }, 100);
						// this.showsugflag = false;
						this.getsugfnc();
						this.showsugflag = true;
						this.showhistroyflag = false;
					}
					if(fromflag){
						this.showsugflag = true;
						this.showhistroyflag = false;
					}
				} else {
					this.keyhistory = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') :
				[];
					this.cachekeyword = '';
					this.showsugflag = false;
					this.showhistroyflag = true;
				}
			},
			hidesug: function() {
				this.showsugflag = false;
				this.showhistroyflag = false;
			},
			searchHistory: function() {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') :
			[];
				if (temphistorylist.indexOf(this.keyword) < 0) {
					if (temphistorylist.length > 4) {
						temphistorylist.pop();
					}
					temphistorylist.unshift(this.keyword);
					this.$cookies.set('keyhistory', temphistorylist.toString(), '30d');
				}
			},
			removehistory: function(key) {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') :
			[];
				if (temphistorylist.indexOf(key) > -1) {
					temphistorylist.splice(temphistorylist.indexOf(key), 1);
					this.keyhistory = temphistorylist;
					this.$cookies.set('keyhistory', temphistorylist.toString(), '30d');
				}
			},
			removehistoryall: function() {
				this.keyhistory = '';
				this.$cookies.remove('keyhistory');
			},
			selhistory: function(key,type) {
				if(type==0){
					this.$track([
						['pagetype','检索中心-推荐关联词-关键词:'+key+'-点击'],
					]);
				}
				else if(type==1){
					this.$track([
						['pagetype','检索中心-检索历史-关键词:'+key+'-点击'],
					]);
				}
				else if(type==2){
					this.$track([
						['pagetype','检索中心-检索热词-关键词:'+key+'-点击'],
					]);
				}
				this.keyword = key;
				this.searchJump();
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword = this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							// debugger;
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function() {
								if (_this.showsugflag && _this.sugwordsList.length > 0) {
									_this.$track([
										['pagetype', 'sug提示'],
										['searchkeyword', _this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if (_this.sugwordsList.length < 1) {
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			gethotwordfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/SearchWordsListInfo',
						responseType: 'json',
						params: {},
					})
					.then(function(response) {
						_this.hotwords = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showDatePanel: function() {
				this.$track([
					['pagetype','检索中心-时间筛选-点击'],
				]);
				this.datePanelVisible = true;
				let _this = this;
				var listenerfunc = function(e) {
					if (!document.getElementById('datePanelDiv').contains(e.target)) {
						_this.datePanelVisible = false;
						document.removeEventListener('click', listenerfunc);
					}
				}
				document.addEventListener('click', listenerfunc)
			},
			dateClick(value, name) {
				// debugger
				if (value == 4 && !this.dateStr) {
					return false;
				}
				this.dateType = value;
				this.dateTypeText = name;
				this.datePanelVisible = false;
				this.pageNum = 1;
				if(this.dateType==4){
					this.$track([
						['pagetype','检索中心-时间筛选-自定义:'+this.dateStr[0] + '#' + this.dateStr[1]+'-点击'],
					]);
				}
				else{
					this.$track([
						['pagetype','检索中心-时间筛选-'+this.dateTypeText+'-点击'],
					]);
				}
				this.searchfnc();
			},
			datepickerClick() {

			},
			searchJump: function() {
				if (this.keyword) {
					if (this.keyword == this.searchword) {
						this.searchClick();
					} else {
						this.$router.push('/search' + (this.keyword ? ('/' + encodeURIComponent(this.keyword)) : ''));
					}

				}
			},
			searchClick: function() {
				// console.log(this.$route.params.searchword);
				// console.log(decodeURIComponent(this.$route.params.searchword));
				this.searchword = this.$route.params.searchword;
				this.keyword = this.searchword;
				document.title = '检索中心-数字中国专版';
				this.$track([
					['pagetype', '搜索'],
					['searchkeyword', this.searchword]
				]);
				if (this.keyword) {
					document.title = this.keyword + '-检索中心-数字中国专版';
					this.searchColum = '';
					this.pageNum = 1;
					this.pageSize = 10;
					this.dateType = 0;
					this.dateTypeText = '时间不限';
					this.searchHistory();
					this.searchfnc();
					this.hidesug();
					// this.searchRelate();
				}
			},
			searchfnc: function() {
				// debugger
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/DEconSearchListInfo',
						responseType: 'json',
						params: {
							lstkey: this.keyword,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							ColID: this.searchColum,
							dateType: this.dateType,
							dateStr: (this.dateType == 4 && this.dateStr && this.dateStr.length > 1) ? (this
								.dateStr[0] + '#' + this.dateStr[1]) : '',
						},
					})
					.then(function(response) {
						if (response.data.data) {
							_this.resultDataList = response.data.data.data.tempResult.artLst;
							_this.resultHitList = response.data.data.data.tempResult.dataList;
							_this.totalResultCount = response.data.data.data.tempResult.totalCount;
							if (_this.totalResultCount == 0) {
								_this.$track([
									['pagetype', '搜索为空'],
									['searchkeyword', _this.searchword]
								]);
							}
							if ((!_this.searchColum) && (_this.pageNum == 1)) {
								_this.totalColumnCount = _this.totalResultCount;
								_this.resultColumnList = response.data.data.data.tempResult.columnCount;
							}
						} else {

						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
			searchColumChange: function(index) {
				// console.log(index);
				this.searchColum = index;
				this.$track([
					['pagetype', '搜索'],
					['reqtype', '2'],
					['column', this.searchColum],
					['searchkeyword', this.searchword]
				]);
				this.pageNum = 1;
				this.pageSize = 10;
				this.searchfnc();
			},
			showZCJD: function(artid) {
				this.zcjdsearchfnc(artid);
				this.zcjdPanelVisible = true;
				document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
			},
			hideZCJD: function(artid) {
				this.zcjdPanelVisible = false;
				document.getElementsByTagName('body')[0].style.overflowY = 'auto';
			},
			zcjdsearchfnc: function(artid) {
				let _this = this;
				let _artid = artid;
				_this.loadingMaskZcjd = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/artRelListInfo',
						responseType: 'json',
						params: {
							artID: artid,
							iPageNum: this.zcjdpageNum,
							iPageSize: 10,
						},
					})
					.then(function(response) {
						_this.zcjdresultDataList = response.data.data.data.tempResult.artLst;
						_this.zcjdtotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype', '政策解读'],
							['reqtype', '1'],
							['pageid', _artid]
						]);
						_this.loadingMaskZcjd = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMaskZcjd = false;
					});
			},
			zcjdchangeSearchPage: function(page) {
				// console.log(page);
				this.zcjdpageNum = page;
				this.zcjdsearchfnc();
			},
			searchRelate: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/RelateWordListInfo',
						responseType: 'json',
						params: {
							lstkey: this.keyword,
						},
					})
					.then(function(response) {
						_this.relateDataList = response.data.data.data.Similarkeyword ? response.data.data.data
							.Similarkeyword.split('|') : [];
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>
</style>
